import React, { useState, useCallback } from "react";
import { Row } from "react-bootstrap";
import "./Login.css";
import instance from "../../Api";
import Loader from "../common/Loader";
import toast, { Toaster } from "react-hot-toast";
import AppToast from "../../AppToast";

// ─── Main Component ───────────────────────────────────────────────────────────
const ForgotPassword = ({ isMobile }) => {
  // Fix: original used useState(null) then checked `email !== null`.
  // An empty string also passes `null !== null` → false, but a typed+cleared
  // field sets email to "" which also passes `"" !== null` → API called with "".
  // Using "" as initial state and !email as guard handles both cases correctly.
  const [email,   setEmail]   = useState("");
  const [loading, setLoading] = useState(false);

  const showToast = useCallback((msg) =>
    toast((t) => <AppToast id={t.id} message={msg} isMobile={isMobile} />),
    [isMobile]);

  const ForgotPassCall = useCallback(async () => {
    if (!email) { showToast("Please enter your email address."); return; }
    setLoading(true);
    try {
      const res = await instance.post("/forget-password", { email });
      showToast(res.data.message);
      if (res.data.status) window.location.href = "/";
    } catch (error) {
      console.error("Error during the forgot password process:", error);
    }
    setLoading(false);
  }, [email, showToast]);

  // ── Shared form — defined once, rendered in both mobile and web ───────────
  // Original had the entire form (email input + button + sign-up link) written
  // twice with identical JSX. The only difference was the outer container's
  // top offset and the page heading text.
  const form = (
    <div style={{ display: "grid", justifyItems: "stretch" }}>
      <div style={{ padding: "15px", textAlign: "center", color: "#fff", fontSize: "24px" }}>
        Reset Password
      </div>

      {/* Email input */}
      <div style={{ marginTop: "15px", display: "flex", alignItems: "center", border: "2px solid white", borderRadius: "25px", padding: "5px" }}>
        <img src="/images/email.png" alt="" style={{ width: "20px", height: "15px", marginRight: "5px" }} />
        <input
          value={email}
          type="text"
          id="Email"
          className="form-control white-placeholder"
          name="Email"
          placeholder="Enter Email"
          style={{ color: "white", border: "none", outline: "none", background: "transparent", flex: "1", padding: "5px" }}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      {/* Submit button */}
      <div className="log-in" style={{ marginTop: "15px", marginLeft: "-8rem", justifyContent: "center" }} onClick={ForgotPassCall}>
        <a className="media-link">
          <div className="media-banner" style={{ width: "auto", height: "50px", marginTop: "10px", marginLeft: "10rem" }}>
            <img className="normal-banner"    src="/images/signup-btn-bg.png"     alt="" style={{ marginTop: "-6px", width: "12rem", height: "4rem" }} />
            <img className="hover-img-banner" src="/images/search-btn-hover.png" alt="" style={{ marginTop: "-6px", width: "12rem", height: "4rem" }} />
            <span className="login-text" style={{ fontSize: "20px", color: "#07528B", marginTop: "0px" }}>Submit</span>
          </div>
        </a>
      </div>

      {/* Sign Up link */}
      <div style={{ display: "flex", marginTop: "30px" }}>
        <span className="rgst mob" style={{ color: "#fff", display: "inline-block", fontSize: "17px", padding: "3px 0 0" }}>
          Don't you have an account?
        </span>
        <a href="/signUp" style={{ fontSize: "20px", display: "unset", background: "unset", padding: "0 0 0 3px", color: "#fff", textDecoration: "underline", textTransform: "capitalize", fontWeight: "500" }}>
          Sign Up
        </a>
      </div>
    </div>
  );

  const cardStyle = (top) => ({
    backgroundImage: `url("/images/blue-box-bg.svg")`,
    backgroundSize: "cover",
    top,
    width: "90%",
    marginLeft: "25px",
    padding: "30px 25px",
    position: "relative",
    backgroundColor: "#07528b",
    borderRadius: "12px",
    flexWrap: "wrap",
  });

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div style={{ width: "100%", minHeight: "55rem", position: "relative", backgroundImage: "url(./main-bg.jpg)", backgroundSize: "cover", backgroundRepeat: "round", backgroundBlendMode: "overlay" }}>
      <div className="apptoast-align">
        <Toaster position={isMobile ? "top-center" : "bottom-right"} reverseOrder={false} />
      </div>

      {isMobile ? (
        /* ── MOBILE ──────────────────────────────────────────────────────── */
        <>
          <div className="heading-dotted-changepass">Forgot Password <span /></div>
          <div style={cardStyle("6rem")}>{form}</div>
        </>
      ) : (
        /* ── WEB ─────────────────────────────────────────────────────────── */
        <>
          <div className="heading-dotted-changepass">Reset Password <span /></div>
          <Row>
            <div className="col-md-4" />
            <div className="col-md-4">
              <div style={cardStyle("10rem")}>{form}</div>
            </div>
            <div className="col-md-4" />
          </Row>
        </>
      )}

      {loading && (
        <div className="loading-overlay" style={{ zIndex: "9999999999999999" }}>
          <Loader isLoading={loading} />
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;